import { startOfToday } from "date-fns";
import {
  getLastMonth,
  getCurrentMonth,
  getCurrentWeek,
  getLastNDays,
  getLastWeek,
  getNext30Days,
  getMoreThanNDays,
} from "@/utils/date";
import { getNextNDays } from "@/utils/date";

export enum DatePeriods {
  NEXT_30_DAYS = "next_30_days",
  CURRENT_WEEK = "current_week",
  CURRENT_MONTH = "current_month",
  LAST_WEEK = "last_week",
  LAST_MONTH = "last_month",
  LAST_3_DAYS = "last_3_days",
  LAST_7_DAYS = "last_7_days",
  LAST_30_DAYS = "last_30_days",
  ALL_PAST_DATES = "all_past_dates",
  NO_PREVIOUS_APPTS = "no_previous_appts",
  LAST_3_MONTHS = "last_3_months",
  LAST_6_MONTHS = "last_6_months",
  NO_APPT_SCHEDULED = "no_appt_scheduled",
  NEXT_WEEK = "next_week",
  NEXT_MONTH = "next_month",
  NEXT_3_MONTHS = "next_3_months",
  NEXT_6_MONTHS = "next_6_months",
  MORE_THAN_1_DAY = "more_than_1_day",
  MORE_THAN_3_DAYS = "more_than_3_days",
  MORE_THAN_7_DAYS = "more_than_7_days",
  ALL_TIME = "all_time",
  ALL_FUTURE_DATES = "all_future_dates",
  CUSTOM_DATES = "custom_dates",
}

export const DEFAULT_PERIOD_OPTIONS = [
  DatePeriods.NEXT_30_DAYS,
  DatePeriods.CURRENT_MONTH,
  DatePeriods.LAST_MONTH,
  DatePeriods.CURRENT_WEEK,
  DatePeriods.LAST_WEEK,
];

export const DATE_PERIOD_LABELS = {
  [DatePeriods.NEXT_30_DAYS]: "Next 30 days",
  [DatePeriods.NEXT_MONTH]: "Next month",
  [DatePeriods.CURRENT_WEEK]: "Current week",
  [DatePeriods.CURRENT_MONTH]: "Current month",
  [DatePeriods.LAST_WEEK]: "Last week",
  [DatePeriods.LAST_MONTH]: "Last month",
  [DatePeriods.LAST_3_DAYS]: "Last 3 days",
  [DatePeriods.LAST_7_DAYS]: "Last 7 days",
  [DatePeriods.LAST_30_DAYS]: "Last 30 days",
  [DatePeriods.NO_PREVIOUS_APPTS]: "No previous appointments",
  [DatePeriods.LAST_3_MONTHS]: "Last 3 months (90 days)",
  [DatePeriods.LAST_6_MONTHS]: "Last 6 months (180 days)",
  [DatePeriods.ALL_PAST_DATES]: "All past dates",
  [DatePeriods.NO_APPT_SCHEDULED]: "No appointment scheduled",
  [DatePeriods.NEXT_WEEK]: "Next week",
  [DatePeriods.NEXT_3_MONTHS]: "Next 3 months (90 days)",
  [DatePeriods.NEXT_6_MONTHS]: "Next 6 months (180 days)",
  [DatePeriods.ALL_FUTURE_DATES]: "All future dates",
  [DatePeriods.CUSTOM_DATES]: "Custom dates",
  [DatePeriods.ALL_TIME]: "All time",
  [DatePeriods.MORE_THAN_1_DAY]: "More than 1 day",
  [DatePeriods.MORE_THAN_3_DAYS]: "More than 3 days",
  [DatePeriods.MORE_THAN_7_DAYS]: "More than 7 days",
};

export const getTimeRange = (period: DatePeriods) => {
  return {
    [DatePeriods.NEXT_30_DAYS]: getNext30Days(),
    [DatePeriods.CURRENT_WEEK]: getCurrentWeek(),
    [DatePeriods.LAST_WEEK]: getLastWeek(),
    [DatePeriods.CURRENT_MONTH]: getCurrentMonth(),
    [DatePeriods.LAST_MONTH]: getLastMonth(),
    [DatePeriods.LAST_3_DAYS]: getLastNDays(3),
    [DatePeriods.LAST_7_DAYS]: getLastNDays(7),
    [DatePeriods.LAST_30_DAYS]: getLastNDays(30),
    [DatePeriods.LAST_3_MONTHS]: getLastNDays(90),
    [DatePeriods.LAST_6_MONTHS]: getLastNDays(180),
    [DatePeriods.ALL_PAST_DATES]: { startDate: null, endDate: startOfToday() },
    [DatePeriods.NO_PREVIOUS_APPTS]: { startDate: null, endDate: null },
    [DatePeriods.NO_APPT_SCHEDULED]: { startDate: null, endDate: null },
    [DatePeriods.NEXT_WEEK]: getNextNDays(7),
    [DatePeriods.NEXT_MONTH]: getNextNDays(30),
    [DatePeriods.NEXT_3_MONTHS]: getNextNDays(90),
    [DatePeriods.NEXT_6_MONTHS]: getNextNDays(180),
    [DatePeriods.MORE_THAN_1_DAY]: getMoreThanNDays(1),
    [DatePeriods.MORE_THAN_3_DAYS]: getMoreThanNDays(3),
    [DatePeriods.MORE_THAN_7_DAYS]: getMoreThanNDays(7),
    [DatePeriods.ALL_TIME]: {
      startDate: null,
      endDate: null,
    },
    [DatePeriods.ALL_FUTURE_DATES]: {
      startDate: startOfToday(),
      endDate: null,
    },
    [DatePeriods.CUSTOM_DATES]: { startDate: null, endDate: null },
  }[period];
};
